/**
 * @module auth.slice
 */
import { createSlice } from '@reduxjs/toolkit'

const AuthSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    accessToken: undefined,
    isAuthLoading: true,
  },
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload
    },
    setIsAuthLoading: (state, action) => {
      state.isAuthLoading = action.payload
    },
  },
})

export const { setIsAuthenticated, setAccessToken, setIsAuthLoading } = AuthSlice.actions

export const selectIsAuthenticated = (state) => state?.auth?.isAuthenticated
export const selectAccessToken = (state) => state?.auth?.accessToken
export const selectIsAuthLoading = (state) => state?.auth?.isAuthLoading

export default AuthSlice.reducer
